import React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Button,
  Typography,
  Stack,
  TextField,
  CircularProgress,
} from '@mui/material';
import Form from 'react-bootstrap/Form';
import FormControl from '@mui/material/FormControl';
import { postRequest } from '../../../../lib/api';
import toast from 'react-hot-toast';

const Create = () => {
  const navigate = useNavigate();
  const { id: customer_id } = useParams(); 
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    const created_id = localStorage.getItem('id'); 
    const payload = {
      note: data.note,
      created_id,
      customer_id,
    };

    try {
      const response = await postRequest('private/createNotes', payload);
      if (response?.status === 200) {
     //   toast.success('Note added successfully');
        reset(); // clear the form
        navigate(-1); // go back
      } else {
       // toast.error(response?.message || 'Failed to add note');
      }
    } catch (err) {
      //toast.error('Something went wrong');
    }
  };

  return (
    <div>
      <Typography variant="h5" mb={3}>
        Notes
      </Typography>

      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group className="mb-3">
          <FormControl sx={{ my: 1, width: '100%' }} variant="outlined">
            <TextField
              label="Write Note Here"
              multiline
              rows={4}
              {...register('note', { required: 'Note is required' })}
              error={Boolean(errors.note)}
              helperText={errors.note?.message}
            />
          </FormControl>
        </Form.Group>

        <Stack direction="row" spacing={2}>
          <Button
            variant="outlined"
            color="inherit"
            type="button"
            onClick={() => navigate(-1)}
          >
            Cancel
          </Button>
          <Button variant="contained" className='red-bg red-button text-capitalize'
  type="submit" disabled={isSubmitting}>
            {isSubmitting ? <CircularProgress size={20} color="inherit" /> : 'Submit'}
          </Button>
        </Stack>
      </Form>
    </div>
  );
};

export default Create;
